import React from 'react';
import { RatingLayout } from '../rating.layout';
import { PagePath } from '../../../../navigation/navigation.enums';

export function SelfAssessmentPage(): JSX.Element {
  return <RatingLayout path={PagePath.analysisSelfAssessment} title="Self Assessment" subtitle="Rate your level of expertise in each of the skills below, as well as how many years you have been using the skill." type="self" />;
}